import React, {useEffect, useState} from 'react';
import {connect, DispatchProp} from "react-redux";
import {Navigate, useLocation} from "react-router-dom";
import {RootState} from "../../../reducers";
import LoadingContainer from "../../components/Common/LoadingContainer";
import {useSessionService} from "../../services/Session/sessionService";
import {getSession} from "../../services/Session/reducer";
import AppConfig from "../../services/AppConfig";
import {usePrefix} from "../../services/Prefix";


type Props = ReturnType<typeof mapStateToProps> & DispatchProp;

function DeliveryOrderTypePage(props: Props) {
    const [loading, setLoading] = useState(true);
    const [redirect, setRedirect] = useState(false);
    const orderType = "DELIVERY";
    const sessionService = useSessionService();
    const prefix = usePrefix();
    const location = useLocation()


    const init = async () => {

        let sessionData = {
            ...props.session,
            order_type: orderType
        }

        try {
            await sessionService.update(sessionData);
            // await props.dispatch(updateOrderData({type: orderType}, props.cart));
            setRedirect(true);
        } catch (error) {
        }
    }
    useEffect(() => {

        init();
    }, []);

    if (redirect) {
        return (
            <Navigate to={{pathname: AppConfig.getLinkWithPrefix("/", prefix), search: location.search}}/>
        )
    }
    if (loading) {
        return (
            <LoadingContainer/>
        );
    }
    return (
        <Navigate to={{pathname: AppConfig.getLinkWithPrefix("/", prefix), search: location.search}}/>
    )
}

const mapStateToProps = (state: RootState) => ({
    session: getSession(state.session)
})

const connector = connect(mapStateToProps);

export default connector(DeliveryOrderTypePage);
